export let SettingsTypes = /*#__PURE__*/function (SettingsTypes) {
  SettingsTypes["TurnaroundTime"] = "TurnaroundTime";
  SettingsTypes["FlatRates"] = "FlatRates";
  SettingsTypes["SuperSpeed"] = "SuperSpeed";
  SettingsTypes["DefaultWarehouse"] = "DefaultWarehouse";
  SettingsTypes["ShippingMargin"] = "ShippingMargin";
  SettingsTypes["SpaceShippingMargin"] = "SpaceShippingMargin";
  SettingsTypes["MostPopularGoodieBudget"] = "MostPopularGoodieBudget";
  SettingsTypes["GoodieFlatRates"] = "GoodieFlatRates";
  SettingsTypes["CrinklePaperSku"] = "CrinklePaperSku";
  SettingsTypes["ReplacementPriceRange"] = "ReplacementPriceRange";
  SettingsTypes["HubspotCalendarLinks"] = "HubspotCalendarLinks";
  SettingsTypes["ShippingFallBackMultipliers"] = "ShippingFallBackMultipliers";
  SettingsTypes["ShipoutShutdown"] = "ShipoutShutdown";
  SettingsTypes["ShipoutShutdownStorageFee"] = "ShipoutShutdownStorageFee";
  SettingsTypes["CIShipoutShutdown"] = "CIShipoutShutdown";
  return SettingsTypes;
}({});
export let ShipoutShutdownState = /*#__PURE__*/function (ShipoutShutdownState) {
  ShipoutShutdownState["PRE_SHUTDOWN"] = "PRE_SHUTDOWN";
  ShipoutShutdownState["SHUTDOWN"] = "SHUTDOWN";
  ShipoutShutdownState["WORKING"] = "WORKING";
  return ShipoutShutdownState;
}({});
export let ShippingMargin = /*#__PURE__*/function (ShippingMargin) {
  ShippingMargin["domesticShippingMargin"] = "domesticShippingMargin";
  ShippingMargin["internationalShippingMargin"] = "internationalShippingMargin";
  ShippingMargin["taxesAndDutiesMargin"] = "taxesAndDutiesMargin";
  return ShippingMargin;
}({});